import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { Box, Container } from '@mui/material';
import { COLOR_GRAY_20 } from 'styles/variables/colors';
import Faq from '../Faq/index';
import GraphicalThreeSteps from 'components/GraphicalThreeSteps';
import PricingContent from 'components/PricingContent';
import TrustedByResearchers from 'components/TrustedByResearchers';
import CarouselGraphicalAbstractsVariant from 'components/CarouselGraphicalAbstractsVariant';
import { flowTrialActive } from 'utils';
import PricingContentAlternative from 'components/PricingContentAlternative';
import { checkUserCountry } from 'utils/locale';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function MainContent() {
  const { user } = useAuthUser();
  const [userIsChina, setUserIsChina] = useState(false);
  const [userIsJapan, setUserIsJapan] = useState(false);

  async function getCountryFromUser() {
    const isChina = await checkUserCountry.isChina(user);
    const isJapan = await checkUserCountry.isJapan(user);

    setUserIsChina(isChina);
    setUserIsJapan(isJapan);
  }

  useEffect(() => {
    getCountryFromUser();
  }, [user]);

  return (
    <>
      <GraphicalThreeSteps showButton={false} />

      <Box id="pricing-content">
        {flowTrialActive && !(userIsChina || userIsJapan) ? (
          <PricingContentAlternative />
        ) : (
          <PricingContent title="Check Out Our Subscription Plans" bgColorProp={COLOR_GRAY_20} />
        )}
      </Box>

      <Box bgcolor="#fff" pb={4}>
        <TrustedByResearchers
          title={
            <>
              <span>Trusted by</span> researchers and academics from 100+ institutions
            </>
          }
          variantTitle={'h5'}
        />
      </Box>

      <LazyLoad offset={100}>
        <CarouselGraphicalAbstractsVariant />
      </LazyLoad>

      <LazyLoad offset={100}>
        <Box py={6}>
          <Container>
            <Faq />
          </Container>
        </Box>
      </LazyLoad>
    </>
  );
}
